export const SCATTER_QUADRANT_CONSTANTS : {name: string}[] = [
	{name: 'NEEDS DEVELOPMENT'},
	{name: 'FUTURE PROOFING'},
	{name: 'ACHIEVER'},
	{name: 'PRIORITIZING EARTH'}
];